import Hero from "@/components/sections/Hero";
import WhyChoose from "@/components/sections/WhyChoose";
import Contact from "@/components/sections/Contact";
import Patologie from "@/components/sections/Patologie";
import Prestazioni from "@/components/sections/Prestazioni";
import Onorari from "@/components/sections/Onorari";
import NutrizioneTeaser from "@/components/sections/NutrizioneTeaser";
import Timeline from "@/components/sections/Timeline";
import Testimonials from "@/components/sections/Testimonials";
import ChiSono from "@/components/sections/ChiSono";
import Locations from "@/components/sections/Locations";
import FAQSection from "@/components/sections/FAQSection";
import FinalCTA from "@/components/sections/FinalCTA";
import SEO from "@/components/SEO";
import { physicianSchema, faqSchema, graphSchema } from "@/lib/schema";
import { FAQ } from "@/data/siteData";

export default function Home() {
  const jsonLd = graphSchema([physicianSchema(), faqSchema(FAQ)]);
  return (
    <main data-testid="home-page">
      <SEO
        title="Gastroenterologo a Cagliari e Portoscuso"
        description="Dr. Cristian Santus, gastroenterologo in Sardegna. Visite specialistiche, second opinion e percorsi di cura personalizzati a Portoscuso, Carloforte, Sestu e Cagliari. 75+ recensioni a 5 stelle."
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <WhyChoose />
      <Contact />
      <Prestazioni />
      <Onorari />
      <NutrizioneTeaser />
      <Patologie />
      <Timeline />
      <Testimonials />
      <ChiSono />
      <Locations />
      <FAQSection />
      <FinalCTA />
    </main>
  );
}
